export default __webpack_public_path__ + "static/media/chat.d7e65084.svg";